import React, { useEffect } from "react";
import PrintExport from "../../../components/common/ui/Export/PrintExport";
import { history } from "../../../_helpers";
import Button from "../../../components/common/ui/Button";
import { useDispatch, useSelector } from "react-redux";
import { staffRequestAction } from "../../../_store";
import { showToastNotification } from "../../../components/common/ui/NotificationModal/ToastNotication";
import { handleReviewPrivateConvoNavigator } from "./ReviewPrivateConvoNavigator";

function PrivateConvoRequestFormHeader({
  handlePrints,
  list,
  showFeedBack,
  handleFeedBack,
  source,
  navigateBack,
  errorMessage,
  setErrorMessage,
  setRequestFormData,
  requestFormSubmitted,
  setRequestFormSubmitted,
  setUpdateRequestColumn,
}) {
  const dispatch = useDispatch();

  const {
    requestReview,
    indexValue,
    privateConversationSearchListData,
    privateConversationList,
  } = useSelector((x) => x?.staffRequest);

  const facilityCode = useSelector((x) => x?.auth?.commonFacilityCode);

  const { user } = useSelector((x) => x.auth);
  const managementUserID = user?.ManagementUserID;

  useEffect(() => {
    if (
      !requestReview &&
      Object?.keys(list)?.length === 0 &&
      source &&
      source !== "privateConversation"
    ) {
      history?.navigate("StaffRequestList");
    }
  }, []);

  useEffect(() => {
    if (
      !requestReview &&
      list?.DataList?.length > 0 &&
      source === "privateConversation"
    ) {
      history?.navigate("/Admin/StaffRequestList/PrivateConversation");
    }
  }, [requestReview]);

  const handlePrevNext = (direction) => {
    //clear error message when navigate
    setUpdateRequestColumn([]);
    setErrorMessage({});
    //clear request form value when navigate
    setRequestFormData({
      folderPath: "",
      filename: "",
      file: "",
      requestForumThreadID: "",
      facilityID: facilityCode,
      facilityCode: "",
      inmatesId: "",
      managementUserID: managementUserID,
      activeStatus: 0,
      noticesTitle: "",
      pdfAttachPath: "",
      postType: 1,
    });

    if (
      requestFormSubmitted !== undefined &&
      requestFormSubmitted !== null &&
      requestFormSubmitted === true &&
      requestReview
    ) {
      const searchData = { ...privateConversationSearchListData };
      searchData.facilityID = facilityCode;
      searchData.ActiveStatus =
        searchData.ActiveStatus === 3 ? 2 : searchData.ActiveStatus;
      searchData.ManagementUserID = managementUserID;
      searchData.PageNo = 1;
      // searchData.RowCountPerPage = 10;
      searchData.RowCountPerPage = privateConversationList?.TotalRecordCount;
      dispatch(
        staffRequestAction?.LoadPrivateConversationRequestReviewAllList(
          searchData
        )
      )
        .then((result) => {
          if (result?.payload) {
            const data = result?.payload;
            handleReviewPrivateConvoNavigator(
              direction,
              data,
              direction === "next" ? indexValue : indexValue == 0 ? indexValue : indexValue - 1,
              history,
              "privateConversation",
              dispatch
            );
          }
        })
        .catch((err) => {
          showToastNotification("Something went wrong", "error");
        });

      setRequestFormSubmitted(false);
      return;
    }

    const index = indexValue;
    dispatch(staffRequestAction?.updateReviewStatus(true));
    if (!requestReview) return;
    var updateIndex = direction === "next" ? index + 1 : index - 1;
    if (direction === "prev" && indexValue === 0) {
      updateIndex = list?.DataList?.length - 1;
    }
    if (direction === "next" && list?.DataList?.length === indexValue + 1) {
      updateIndex = 0;
    }
    dispatch(staffRequestAction?.updateIndexValue(updateIndex));
    const row = list?.DataList[updateIndex];

    history.navigate("StaffRequestList/PrivateConversationRequestForm", {
      state: {
        formID: row?.RequestFormTypeID,
        RequestFormType: row?.RequestFormType,
        InmateID: row?.InmateID,
        InmateResidentId: row?.InmateResidentId,
        formDetails: list,
        sourceFrom: "privateConversation",
      },
    });
  };

  return (
    <div className="d-flex flex-wrap justify-content-end gap-3">
      {requestReview &&
        (indexValue !== 0 || list?.DataList?.length !== indexValue + 1) && (
          <div className=" d-flex flex-wrap justify-content-center align-items-center gap-3">
            <i
              className={`fas fa-arrow-alt-circle-left fs-2 cursor-pointer ${indexValue === 0 ? "" : ""
                }`}
              onClick={() => handlePrevNext("prev")}
              title="prev"
            ></i>
            <i
              className={`fas fa-arrow-alt-circle-right fs-2 cursor-pointer ${list?.DataList?.length === indexValue + 1 ? "" : ""
                }`}
              onClick={() => handlePrevNext("next")}
              title="next"
            />
          </div>
        )}
      <PrintExport
        handlePrintShow={() => {
          handlePrints();
        }}
      />
      {showFeedBack && (
        <div
          data-bs-toggle="modal"
          data-bs-target="#public-defender-crisp-feedback"
        // onClick={() => handlePCRCount(row)}
        >
          <Button
            label="Feedback"
            type="button"
            status="success"
            onClick={() => handleFeedBack()}
          />
        </div>
      )}
      <Button
        label="Back"
        type="button"
        icon={"fa-solid fa-angle-left"}
        status="primary"
        onClick={() => {
          dispatch(staffRequestAction?.updateReviewStatus(false));
          history?.navigate(
            navigateBack ? navigateBack : "/Admin/StaffRequestList"
          );
          //  dispatch(staffRequestAction?.resetPrivateConversationSearchList());
        }}
      />
    </div>
  );
}

export default React.memo(PrivateConvoRequestFormHeader);
